// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1o9m1","insightsList":"newBusinessInsightsMenu_insightsList__13MzN","active":"newBusinessInsightsMenu_active__3Xt4W"};